<app-confirm-action-modal
  testId="delete-lane-dialog"
  *ngIf="lane"
  title="Delete lane?"
  confirmLabel="Delete"
  [busy]="isSubmitting"
  [mobileSheet]="false"
  (confirm)="onConfirm()"
  (cancel)="onClose()"
>
  <p>
    Delete lane <strong>{{ lane.name }}</strong
    >? This cannot be undone.
  </p>
</app-confirm-action-modal>
